import React from 'react';

import { Navigate, Outlet } from 'react-router-dom';

import { LoadingIndicator } from '@src/components/atoms/loading-indicator';
import { useAuth } from '@src/hooks/use-auth';
import { useGetProfileQuery } from '@src/store/queries/users';
import { USER_ROLES } from '@src/utils/constants';

const AdminRoute = () => {
  const { data: profileData, isFetching: isFetchingUserData } = useGetProfileQuery();
  const { isAuthenticated } = useAuth();

  if (isFetchingUserData) {
    return <LoadingIndicator />;
  }

  if (!isAuthenticated || profileData?.role !== USER_ROLES.admin) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};

export default AdminRoute;
